<header-row [userName]="'Victoria Brown'" [userRole]="'REGIONAL MANAGER'"></header-row>

<div class="hospital-editor page-layout">
   <div class="dashboard-header">
      <div class="hospital-title">
    <div class="back" (click)="locationBack()">
      <span class="material-icons">arrow_back</span>
    </div>
  <h1 class="page-title">{{ selectedHospital.name }}</h1>
  </div>
 <div class="header-controls">
      <div class="select-wrap-qtr">
        <select class="quarter-select" [(ngModel)]="selectedQuarter" (ngModelChange)="applyQtr()">
          <option value="default">Filter by Quarter</option>
          <option *ngFor="let quarter of quarterList" [value]="quarter.quarterName">
            {{ quarter.quarterName }}
          </option>
        </select>
      </div>
    </div> 
  </div>
  <!-- Hospital Title -->

  <!-- Top Section: Performance & Meetings -->
  <div class="top-section">
    <!-- Performance Overview Card -->
    <div class="card performance-overview">
      <div class="card-header">
        <h2>Performance Overview</h2>
        <button class="icon-btn">
          <span class="material-icons">hub</span>
        </button>
      </div>
      <div class="metrics-grid">
        <!-- New Patients -->
        <div class="metric-card teal-bg">
          <div class="metric-icon">
            <span class="material-icons">pets</span>
          </div>
          <span class="trend-badge green">+12%</span>
          <div class="metric-value">23</div>
          <div class="metric-label">New Patients<br>per Week</div>
        </div>
        <!-- Service Visits -->
        <div class="metric-card orange-bg">
          <div class="metric-icon">
            <span class="material-icons">apartment</span>
          </div>
          <span class="trend-badge green">+5%</span>
          <div class="metric-value">38</div>
          <div class="metric-label">Service Visits<br>per Week</div>
        </div>
        <!-- Avg Working Hours -->
        <div class="metric-card purple-bg">
          <div class="metric-icon">
            <span class="material-icons">schedule</span>
          </div>
          <span class="trend-badge green">+15%</span>
          <div class="metric-value">1.5hrs</div>
          <div class="metric-label">Avg Working<br>Hours per Visit</div>
        </div>
        <!-- Achieved Revenue -->
        <div class="metric-card green-bg">
          <div class="metric-icon">
            <span class="material-icons">insert_chart</span>
          </div>
          <span class="trend-badge green">+8%</span>
          <div class="metric-value">$10.6k</div>
          <div class="metric-label">Achieved Revenue<br>per Week</div>
        </div>
      </div>
    </div>

    <!-- Meeting Schedule Card -->
    <!-- <div class="card meeting-schedule">
      <div class="card-header">
        <h2>Meeting Schedule</h2>
        <button class="btn-schedule" (click)="scheduleMeeting()">
          <span class="material-icons">add</span>
          Schedule Meeting
        </button>
      </div>
      <div class="meetings-content">
        <div class="meeting-item next">
          <div class="meeting-left">
            <span class="meeting-title">Next Meeting</span>
            <div class="meeting-datetime">
              <span class="material-icons">calendar_today</span>
              Tuesday, November 25, 2025
            </div>
            <div class="meeting-datetime">
              <span class="material-icons">schedule</span>
              12:30 PM - 1:00 PM
            </div>
          </div>
          <button class="btn-join" (click)="joinMeeting(nextMeeting)">
            <span class="material-icons">videocam</span>
            Join Meeting
          </button>
        </div>

        <div class="meeting-item last">
          <div class="meeting-left">
            <span class="meeting-title">Last Meeting</span>
            <div class="meeting-datetime">
              <span class="material-icons">calendar_today</span>
              Monday, September 6, 2025
            </div>
            <div class="meeting-datetime">
              <span class="material-icons">schedule</span>
              11:00 AM - 11:30 AM
            </div>
          </div>
          <button class="btn-notes" (click)="viewMeetingNotes(lastMeeting)">
            <span class="material-icons">description</span>
            View Meeting Notes
          </button>
        </div>
      </div>
    </div> -->
  </div>

  <!-- Hospital Goals Section -->
  <div class="hospital-goals-section">
    <div class="goals-header">
      <h2>Hospital Goals</h2>
      <p class="goals-subtitle">Enable the goals & corresponding targets below that you would like to assign to this hospital. Press the save button when complete.</p>
    </div>

    <div class="goals-controls">
      <div class="quarter-tabs">
        <button class="quarter-btn active">Q1 2025</button>
        <button class="quarter-btn">
          Q2 2025
          <span class="notification-badge">3</span>
        </button>
        <button class="quarter-btn">Q3 2025</button>
        <button class="quarter-btn">Q4 2025</button>
      </div>
      <a class="view-previous-link">View goals from previous quarters »</a>
      <div class="goals-actions">
        <button class="btn-assign" (click)="assignNewGoal()">
          <span class="material-icons">add</span>
          Assign New Goal
        </button>
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons">edit</span>
          Edit Goals
        </button>
        <button class="btn-save" (click)="saveGoalPlan()">
          <span class="material-icons">cloud_upload</span>
          Save Goal Plan
        </button>
      </div>
    </div>

    <!-- Goals Live -->
    <div class="goals-category">
      <div class="category-header">
        <span class="material-icons check-icon">check</span>
        <h3>Goals Live</h3>
      </div>

      <!-- Expand Hours Goal -->
      <div class="goal-card">
        <div class="goal-row-top">
          <div class="goal-left">
            <span class="material-icons goal-checkbox checked">check_box</span>
            <h4 class="goal-name">Expand Hours</h4>
          </div>
          <div class="goal-right">
            <div class="progress-section">
              <span class="progress-label">Progress</span>
              <div class="progress-bar-wrapper">
                <div class="progress-bar-bg">
                  <div class="progress-bar-fill" style="width: 90%"></div>
                </div>
                <span class="progress-percent">90%</span>
              </div>
            </div>
            <span class="status-badge live">Live</span>
            <span class="material-icons chevron">chevron_right</span>
          </div>
        </div>
        <div class="goal-row-bottom">
          <div class="metric-col">
            <span class="metric-label">VETCOR AVG.</span>
            <span class="metric-value">30 hours/week</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">CURRENT</span>
            <span class="metric-value">35 hours/week</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">RECOMMENDED</span>
            <span class="metric-value">38 hours/week</span>
          </div>
          <div class="metric-col target-col">
            <span class="metric-label">TARGET</span>
            <input type="text" class="target-input" value="40" />
          </div>
          <div class="metric-col reasoning-col">
            <span class="metric-label">REASONING</span>
            <input type="text" class="reasoning-input" value="Extending hours a bit more will improve customer accessibility" />
          </div>
          <div class="metric-col due-col">
            <span class="metric-label">DUE BY</span>
            <div class="due-date">
              <span>End of Q1</span>
              <span class="material-icons calendar-icon">calendar_today</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Optimize Online Booking Goal -->
      <div class="goal-card">
        <div class="goal-row-top">
          <div class="goal-left">
            <span class="material-icons goal-checkbox checked">check_box</span>
            <h4 class="goal-name">Optimize Online Booking</h4>
          </div>
          <div class="goal-right">
            <div class="progress-section">
              <span class="progress-label">Progress</span>
              <div class="progress-bar-wrapper">
                <div class="progress-bar-bg">
                  <div class="progress-bar-fill gray" style="width: 30%"></div>
                </div>
                <span class="progress-percent">30%</span>
              </div>
            </div>
            <span class="status-badge live">Live</span>
            <span class="material-icons chevron">chevron_right</span>
          </div>
        </div>
        <div class="goal-row-bottom">
          <div class="metric-col">
            <span class="metric-label">VETCOR AVG.</span>
            <span class="metric-value">22 hours/week</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">CURRENT</span>
            <span class="metric-value">26 hours/week</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">RECOMMENDED</span>
            <span class="metric-value">30 hours/week</span>
          </div>
          <div class="metric-col target-col">
            <span class="metric-label">TARGET</span>
            <input type="text" class="target-input" value="32" />
          </div>
          <div class="metric-col reasoning-col">
            <span class="metric-label">REASONING</span>
            <input type="text" class="reasoning-input" value="Adding a few more hours will reduce phone call volume" />
          </div>
          <div class="metric-col due-col">
            <span class="metric-label">DUE BY</span>
            <div class="due-date">
              <span>End of Q1</span>
              <span class="material-icons calendar-icon">calendar_today</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Goals Pending HM/RM Review -->
    <div class="goals-category pending-hm">
      <div class="category-header">
        <span class="material-icons pending-icon">people</span>
        <h3>Goals Pending HM/RM Review</h3>
      </div>

      <!-- Tail-O-Phone Goal -->
      <div class="goal-card pending-card">
        <div class="goal-row-top">
          <div class="goal-left">
            <span class="material-icons goal-checkbox checked">check_box</span>
            <h4 class="goal-name">Tail-O-Phone</h4>
          </div>
          <div class="goal-right">
            <div class="progress-section">
              <span class="progress-label">Progress</span>
              <div class="progress-bar-wrapper">
                <div class="progress-bar-bg">
                  <div class="progress-bar-fill pending" style="width: 0%"></div>
                </div>
                <span class="progress-percent">0%</span>
              </div>
            </div>
            <span class="status-badge pending">HM/RM Review</span>
            <span class="material-icons chevron">expand_more</span>
          </div>
        </div>
        <div class="goal-row-bottom">
          <div class="metric-col">
            <span class="metric-label">VETCOR AVG.</span>
            <span class="metric-value">30 dispositions/day</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">CURRENT</span>
            <span class="metric-value">5 dispositions/day</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">RECOMMENDED</span>
            <span class="metric-value">15 dispositions/day</span>
          </div>
          <div class="metric-col target-col">
            <span class="metric-label">TARGET</span>
            <input type="text" class="target-input" value="10" />
          </div>
          <div class="metric-col reasoning-col">
            <span class="metric-label">REASONING</span>
            <input type="text" class="reasoning-input" value="Inputted here is a reason why the target is lower than the recommended target" />
          </div>
          <div class="metric-col due-col">
            <span class="metric-label">DUE BY</span>
            <div class="due-date">
              <span>End of Q1</span>
              <span class="material-icons calendar-icon">calendar_today</span>
            </div>
          </div>
        </div>

        <!-- Tools & Resources Section -->
        <div class="tools-resources-section">
          <h5>TOOLS & RESOURCES TO BE SUCCESSFUL</h5>
          <div class="resources-grid">
            <div class="resource-item">
              <span class="material-icons bullet">circle</span>
              <span class="resource-text">Accessible via <a href="#">vetcorone.com</a> to view automated reminders and are past due</span>
            </div>
            <div class="resource-item">
              <span class="material-icons bullet">circle</span>
              <span class="resource-text">Utilize Vetcor's <a href="#">Two-Way Text Templates</a> by preloading commonly used messages into PetDesk</span>
            </div>
            <div class="resource-item">
              <span class="material-icons bullet">circle</span>
              <span class="resource-text"><a href="#">PetDesk</a> Texting Dashboard to reach out to past-due pets with the unique URL</span>
            </div>
            <div class="resource-item">
              <span class="material-icons bullet">circle</span>
              <span class="resource-text">Use the <a href="#">Vetstoria Tracking Link</a> to see how impactful your manual outreach is via text</span>
            </div>
          </div>
        </div>

        <!-- Add a Task Section -->
        <div class="add-task-section">
          <div class="task-header">
            <h5>Add a Task</h5>
            <div class="task-user">
              <span class="material-icons user-icon">person</span>
              <div class="user-info">
                <span class="user-name">Victoria Brown</span>
                <span class="user-date">10/8/2024 9:20 AM</span>
              </div>
            </div>
          </div>
          <textarea placeholder="Please describe your task" rows="4"></textarea>
          <div class="task-actions">
            <div class="assignee-dropdown">
              <span class="material-icons">person</span>
              <span>Assign a User</span>
              <span class="material-icons">expand_more</span>
            </div>
            <button class="btn-add-task">Add Task</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Goals Pending Internal Review -->
    <div class="goals-category pending-internal">
      <div class="category-header">
        <span class="material-icons internal-icon">work</span>
        <h3>Goals Pending Internal Review</h3>
      </div>

      <!-- Activate Paid Ads Goal -->
      <div class="goal-card internal-card">
        <div class="goal-row-top">
          <div class="goal-left">
            <span class="material-icons goal-checkbox checked">check_box</span>
            <h4 class="goal-name">Activate Paid Ads</h4>
          </div>
          <div class="goal-right">
            <div class="progress-section">
              <span class="progress-label">Progress</span>
              <div class="progress-bar-wrapper">
                <div class="progress-bar-bg">
                  <div class="progress-bar-fill internal" style="width: 0%"></div>
                </div>
                <span class="progress-percent">0%</span>
              </div>
            </div>
            <span class="status-badge internal">Internal Review</span>
            <span class="material-icons chevron">chevron_right</span>
          </div>
        </div>
        <div class="goal-row-bottom simple">
          <div class="metric-col">
            <span class="metric-label">VETCOR AVG.</span>
            <span class="metric-value">$250/week</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">CURRENT</span>
            <span class="metric-value">$275/week</span>
          </div>
          <div class="metric-col">
            <span class="metric-label">RECOMMENDED</span>
            <span class="metric-value">$270/week</span>
          </div>
          <div class="metric-col target-col">
            <span class="metric-label">TARGET</span>
            <input type="text" class="target-input" value="$270.00" />
          </div>
          <div class="metric-col spacer"></div>
          <div class="metric-col due-col">
            <span class="metric-label">DUE BY</span>
            <div class="due-date">
              <span>End of Q1</span>
              <span class="material-icons calendar-icon">calendar_today</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
